import { render, staticRenderFns } from "./BcbCampaignList.vue?vue&type=template&id=0c70d6f0&scoped=true"
import script from "./BcbCampaignList.vue?vue&type=script&lang=js"
export * from "./BcbCampaignList.vue?vue&type=script&lang=js"
import style0 from "./BcbCampaignList.vue?vue&type=style&index=0&id=0c70d6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70d6f0",
  null
  
)

export default component.exports